/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mid_Season_PeriodsInputs */



/**
* | output |
* | --- |
* | "Mid-season periods" |
*
* @param {Mid_Season_PeriodsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mid_season_periods = /** @type {((inputs?: Mid_Season_PeriodsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mid_Season_PeriodsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mid-season periods")
	return /** @type {LocalizedString} */ ("Périodes de mi-saison")
});